import { createSelector } from '@reduxjs/toolkit';

export const selectNotifications = createSelector(
  (state) => state.notifications,
  (notifications) =>
    Object.keys(notifications).map((id) => ({ id, ...notifications[id] }))
);
